import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Header } from 'components/Layout/Header/Header';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { Button } from 'components/UI/Button/Button';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { goToPetParentPortal } from 'utils/petParentPortal';

import classes from './AddonsMode.module.scss';

interface AddonsModeErrorProps {
    bookingId?: number;
    title?: string;
    message: string;
}

// Add-ons mode never falls back to the public booking flow: the only way out is the portal.
export const AddonsModeError: React.FC<AddonsModeErrorProps> = ({
    bookingId,
    title = 'We couldn’t open this booking',
    message
}) => {
    const marketplace = useMarketplace();

    return (
        <TwoColumnsLayout header={<Header logo={marketplace.logo} />}>
            <LeftColumn contentClassName={classes.centered}>
                <FontAwesomeIcon icon={faCircleExclamation} className={classes.errorIcon} />

                <h1 className="h2">{title}</h1>

                <p className={classes.message}>{message}</p>

                <Button
                    className={classes.centeredAction}
                    onClick={() => goToPetParentPortal(marketplace.slug, bookingId)}
                >
                    Back to Pet Parent Portal
                </Button>
            </LeftColumn>
        </TwoColumnsLayout>
    );
};
